// @ts-nocheck
import { resetStorefrontCookie, resetStorefrontSession } from "@store/Framework/Services/SessionService";
import { ResetStorefrontSessionCookieModel } from "@store/Framework/Types/ApiModels";
import {
    ApiHandler,
    createHandlerChainRunnerOptionalParameter,
} from "@toolkit/Modules/client-framework/HandlerCreator";

export interface ResetKeepMeLoggedInCookieParameter {}

type HandlerType = ApiHandler<ResetKeepMeLoggedInCookieParameter, ResetStorefrontSessionCookieModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApiForSession: HandlerType = async props => {
    props.apiResult = await resetStorefrontSession(props.parameter);
};

export const RequestDataFromApiForCookie: HandlerType = async props => {
    props.apiResult = await resetStorefrontCookie(props.parameter);
};

export const chain = [PopulateApiParameter, RequestDataFromApiForSession, RequestDataFromApiForCookie];

const resetKeepMeLoggedInCookie = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetKeepMeLoggedInCookie");
export default resetKeepMeLoggedInCookie;
